import axios from "axios";

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_BASEURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

axiosClient.interceptors.request.use(
  (request) => {
    !process.env.REACT_APP_STRAPI_API_TOKEN && console.log("Token Missing!!");
    request.headers.common[
      "Authorization"
    ] = `Bearer ${process.env.REACT_APP_STRAPI_API_TOKEN}`;
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosClient;
